// rick.js — RSE custom theme JS
//
// NOTE: The legacy "deals pop-up" handling (hide the Shopify Forms pop-up, then re-show it on
// .deals-btn click) has been REMOVED. The deal-alerts signup is now a button-triggered modal —
// see sections/deals-modal.liquid. While the old Shopify Forms pop-up FORM is still active
// shop-side, a small temporary suppressor in layout/theme.liquid keeps it hidden and clears the
// stray `inert` it applies; delete that block once the pop-up form is turned off in the Forms app.

function initSwiper(container) {
  const slider = container.querySelector('.product-card-slider');

  if (!slider) return;

  new Swiper(slider, {
    slidesPerView: 2,
    spaceBetween: 12,
    loop: false,

    navigation: {
      nextEl: container.querySelector('.swiper-button-next'),
      prevEl: container.querySelector('.swiper-button-prev'),
    },

    pagination: {
      el: container.querySelector('.swiper-pagination'),
      clickable: true,
    },

    breakpoints: {
      320: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3.5 }
    }
  });
}

// Detect when Shopify loads recommendations, then init the slider.
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('product-recommendations');

  if (!section) return;

  const observer = new MutationObserver(() => {
    if (section.querySelector('.product-card-slider')) {
      initSwiper(section);
      observer.disconnect(); // run only once
    }
  });

  observer.observe(section, {
    childList: true,
    subtree: true
  });
});
